__webpack_require__.p = "/event/2025/ai-or-not/song-painting/";